import { Truck, Container, Bike, Car, CarFront, BatteryCharging, CircleDot, ArrowRight, MessageCircle } from "lucide-react";
import { waLink } from "@/lib/site";

const services = [
  {
    icon: Truck,
    title: "Reboque Asa Delta",
    desc: "Serviço de remoção e transporte de veículos leves utilizando reboque tipo Asa Delta, com agilidade e segurança.",
    img: "/images/guincho-asa-delta-dia.jpeg",
    alt: "Reboque Asa Delta da Brasil Transportes removendo carro em Belém",
  },
  {
    icon: Container,
    title: "Reboque em Plataforma",
    desc: "Transporte seguro de veículos sobre plataforma, indicado quando o veículo precisa ser removido integralmente.",
    img: "/images/guincho-plataforma.jpeg",
    alt: "Transporte de veículo em plataforma pela Brasil Transportes",
  },
  {
    icon: Bike,
    title: "Transporte e Remoção de Motos",
    desc: "Atendimento para motocicletas com equipamentos adequados para transporte e remoção.",
    img: "/images/guincho-moto.jpeg",
    alt: "Transporte de motocicleta pela Brasil Transportes em Belém",
  },
  {
    icon: Car,
    title: "Veículos Leves",
    desc: "Atendimento para carros e veículos leves que necessitam de remoção ou transporte.",
  },
  {
    icon: CarFront,
    title: "Utilitários",
    desc: "Serviço para utilitários compatíveis com os equipamentos disponíveis.",
  },
  {
    icon: BatteryCharging,
    title: "Recarga de Bateria",
    desc: "Assistência para veículos com bateria descarregada, direto no local.",
  },
  {
    icon: CircleDot,
    title: "Troca de Pneu",
    desc: "Auxílio para troca de pneu em situações de emergência.",
  },
];

const slug = (t) => t.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export default function Services() {
  return (
    <section id="servicos" className="bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-4 py-16 md:py-24">
        <p className="text-[#50CF08] uppercase tracking-widest text-sm font-semibold">Serviços</p>
        <h2 className="font-bebas text-4xl md:text-6xl uppercase tracking-tight text-[#FEFB0E] mt-2">
          Reboque, guincho e assistência veicular
        </h2>
        <p className="mt-4 text-base md:text-lg text-neutral-400 max-w-2xl">
          Equipamentos para diferentes tipos de veículos e situações. Escolha o serviço e chame
          direto no WhatsApp.
        </p>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => (
            <article
              key={s.title}
              data-testid={`service-card-${slug(s.title)}`}
              className="bg-[#171717] border border-white/10 rounded-md overflow-hidden flex flex-col transition-all duration-300 hover:-translate-y-2 hover:border-[#FEFB0E] group"
            >
              {s.img && (
                <img
                  src={s.img}
                  alt={s.alt}
                  loading="lazy"
                  className="w-full h-48 object-cover object-center"
                />
              )}
              <div className="p-6 md:p-8 flex flex-col items-start gap-4 grow">
                <s.icon className="w-12 h-12 text-[#FEFB0E] group-hover:scale-110 transition-transform duration-300" />
                <h3 className="font-bebas text-2xl md:text-3xl uppercase tracking-wide">{s.title}</h3>
                <p className="text-sm md:text-base text-neutral-400 leading-relaxed grow">{s.desc}</p>
                <a
                  href={waLink(`Olá! Preciso de ${s.title}. Minha localização é ______ e o veículo é ______.`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`service-cta-${slug(s.title)}`}
                  className="inline-flex items-center gap-2 text-[#50CF08] hover:text-[#FEFB0E] font-bold uppercase text-sm tracking-wide transition-colors focus:outline-none focus:ring-2 focus:ring-[#FEFB0E] rounded"
                >
                  Solicitar este serviço
                  <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            </article>
          ))}

          <div className="bg-[#50CF08] rounded-md p-6 md:p-8 flex flex-col items-start justify-center gap-4">
            <h3 className="font-bebas text-3xl md:text-4xl uppercase tracking-wide text-black leading-none">
              Precisa de reboque? Chame agora
            </h3>
            <p className="text-black/80 font-medium text-sm md:text-base">
              Fale direto com a Brasil Transportes e informe sua localização.
            </p>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="services-whatsapp-btn"
              className="inline-flex items-center gap-3 bg-black hover:bg-neutral-800 text-white font-extrabold uppercase px-6 py-3.5 rounded-md transition-all duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-black"
            >
              <MessageCircle className="w-5 h-5" />
              Solicitar atendimento
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
